import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'

export default function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-gradient-to-br from-slate-50 via-white to-purple-50/60">
      {/* Background glow blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-32 right-1/4 w-96 h-96 bg-blue-200 rounded-full blur-3xl opacity-25" />
        <div className="absolute bottom-0 left-1/3 w-80 h-80 bg-purple-200 rounded-full blur-3xl opacity-20" />
      </div>
      <Sidebar />
      <main className="flex-1 overflow-y-auto min-w-0 relative">
        <Outlet />
      </main>
    </div>
  )
}
